import { render, staticRenderFns } from "./slider-multi.vue?vue&type=template&id=0d2a5321&"
import script from "./slider-multi.vue?vue&type=script&lang=js&"
export * from "./slider-multi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports